// globals: jQuery

import CashFlowIframeDialog from './cashFlowIframeDialog';

const CashFlowFrameDialogRect = {
  width: '640',
  height: '550',
};

class CashFlowFrameDialogService {
  constructor() {
    this._cashFlowIframeDialog = new CashFlowIframeDialog();
    this._containerId = 'cashFlowFrameDialogFormContainer';
  }

  get cashFlowIframeDialog() {
    return this._cashFlowIframeDialog;
  }

  get containerId() {
    return this._containerId;
  }

  /**
     * @returns {*|jQuery|HTMLElement}
     */
  getContainer() {
    return jQuery(`#${this._containerId}`);
  }

  /**
     * @param callback
     * @param params
     */
  init(callback, params) {
    // this.isSuccess = false;
    jQuery(`<div id="${this._containerId}"></div>`).appendTo('body');
    const $cashFlowFrameDialogFormContainer = this.getContainer();
    const cashFlowIframeDialogOptions = params.cashFlowIframeDialogOptions ? params.cashFlowIframeDialogOptions : null;
    let options = {
      onDialogOpened: () => {
        this.cashFlowIframeDialog.onSuccess = (form, data) => {
          this.onSuccess(form, data);
          callback(form, data);
          const $formDialog = jQuery('#cashFlowFrameFormDialog');
          const $dialog = $formDialog.closest('.ca-dialog');
          $dialog.prev('.ui-widget-overlay').remove();
          $dialog.remove();
          $formDialog.remove();
        };
        this.cashFlowIframeDialog.onEmvSuccess = (data) => {
          this.onEmvSuccess(data);
          const $dialog = jQuery('#cashFlowFrameFormDialog').closest('.ca-dialog');
          $dialog.prev('.ui-widget-overlay').remove();
          $dialog.remove();
          jQuery('#cashFlowFrameFormDialog').remove();
        };
        this.cashFlowIframeDialog.init(cashFlowIframeDialogOptions);
      },
    };
    if (params) {
      if (params.dialogOptions) {
        params.dialogOptions.width = CashFlowFrameDialogRect.width;
        params.dialogOptions.height = CashFlowFrameDialogRect.height;
      }
      options = jQuery.extend(options, params);
    }
    $cashFlowFrameDialogFormContainer.cashFlowFrameDialogForm(options);
  }

  onEmvSuccess(data) {
    // stub method for subclasses
  }

  onSuccess(form, data) {
    // stub method for subclasses
  }

  /**
 * Get First Digit By Credit Type
 *
 * @param creditType Credit Type
 */
  getFirstDigitByCreditType(creditType) {
    creditType = creditType.replaceAll(' ', '').toLowerCase();
    const types = {
      americanexpress: {
        name: 'American Express',
        firstDigit: '3',
      },
      mastercard: {
        name: 'MasterCard',
        firstDigit: '5',
      },
      discover: {
        name: 'Discover/Novus',
        firstDigit: '6',
      },
      visa: {
        name: 'Visa',
        firstDigit: '4',
      },
    };
    if (!types[creditType]) {
      return null;
    }
    return types[creditType].firstDigit;
  }

  /**
   * Get first two digit of Year
   */
  getFirstTwoDigitOfYear() {
    const date = new Date();
    const year = date.getFullYear().toString().slice(0, 2);
    return year;
  }

  /**
     * @param callback
     * @param params
     */
  open(callback, params) {
    this.init(callback, params);
    this.getContainer().cashFlowFrameDialogForm('openDialog');
  }
}

class CashFlowFrameDialogServiceBillingInfo extends CashFlowFrameDialogService {
  constructor() {
    super();

    jQuery.widget('ca.cashFlowFrameDialogForm', jQuery.ca.caDialogForm, {
      options: {
        dialog: null,
        form: null,
        formParams: {},
        formUrl: '/cash-flow/get-frame-form',
        dialogOptions: {
          title: '<b>Enter Credit/Debit Card to store on file</b>',
          width: CashFlowFrameDialogRect.width,
          height: CashFlowFrameDialogRect.height,
          caProUI: true,
          staticForm: false,
        },
      },
    });
  }

  onSuccess(form, data) {
    const array = data.expirationDate.split('/');
    let expiration_month = array[0];
    const expiration_year = `20${array[1]}`;
    if (expiration_month.length === 1) {
      expiration_month = `0${expiration_month}`;
    }
    jQuery('#cc_date-month').val(expiration_month);
    jQuery('#cc_date-year').val(expiration_year);
  }

  onEmvSuccess(data) {
    const { request } = data;
    const dataPrepared = {
      cc_merchant_unique_id: data.uniqueId.toString(),
      expiration_month: request.i4go_expirationmonth,
      expiration_year: request.i4go_expirationyear,
      cardConnect_expiry: request.i4go_expirationyear + request.i4go_expirationmonth,
    };

    const $form = jQuery('#paymentMethodEditForm');

    this.cashFlowIframeDialog.setCardConnectParamsToForm($form, dataPrepared, () => {});
    this.onSuccess(null, dataPrepared);
  }
}

class CashFlowFrameDialogServiceRefund extends CashFlowFrameDialogService {
  constructor() {
    super();
  }

  onSuccess(form, data) {
    const associationKeys = {
      cc_number: 'cc_number',
      cc_merchant_unique_id: 'cc_merchant_unique_id',
      cc_expirationyear: 'expiration_year',
      cc_expirationmonth: 'expiration_month',
    };

    jQuery.each(associationKeys, (key, item) => {
      if (!jQuery(`.credit-card-form input[name="${key}"]`).length) {
        jQuery('.credit-card-form').append(`<input type="hidden" name="${key}" value="${data[item]}">`);
      }
      jQuery(`.credit-card-form input[name="${key}"]`).attr('value', data[item]);
    });
  }
}

export {
  CashFlowFrameDialogService,
  CashFlowFrameDialogServiceBillingInfo,
  CashFlowFrameDialogServiceRefund,
};
